export const updateMaturityDateArr = (maturityDateArr) => {
    let updatedMaturityDateArr = [];
    for (let i=0; i<maturityDateArr.length; i++){
        const maturityDateObj = 
            updatedMaturityDateArr.find(elem => elem.investShortName === 
                maturityDateArr[i].investShortName);
        if (maturityDateObj){
            //  date has already been recorded for this investment
        }else{
            updatedMaturityDateArr.push(maturityDateArr[i]);
        }
    }
    return updatedMaturityDateArr;
}
export default updateMaturityDateArr;